module.exports = __webpack_public_path__ + "img/option_bigcommerce.66df8fc7.svg";